import S3Icon from "../../assets/components/sources/S3Icon";

const S3Logomark = ({ height }: { height: number }) => {
  return <S3Icon height={height} />;
};

export default S3Logomark;
